var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30.959,
    height: 40,
    rx: 2.73973,
    stroke: "#055FFB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34253 13.877H27.0275",
    stroke: "#055FFB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34253 18H27.0275",
    stroke: "#055FFB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34253 22H27.0275",
    stroke: "#055FFB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34253 26H27.0275",
    stroke: "#055FFB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8714 29.8787C24.9258 29.8191 25.0196 29.8191 25.074 29.8787L25.8496 30.73C25.8856 30.7696 25.9414 30.7845 25.9924 30.7683L27.0897 30.4188C27.1666 30.3944 27.2479 30.4413 27.2651 30.5201L27.5112 31.6451C27.5226 31.6974 27.5634 31.7382 27.6157 31.7497L28.7407 31.9957C28.8196 32.013 28.8665 32.0942 28.842 32.1711L28.4926 33.2684C28.4763 33.3194 28.4913 33.3752 28.5308 33.4113L29.3821 34.1869C29.4418 34.2412 29.4418 34.3351 29.3821 34.3894L28.5308 35.165C28.4913 35.201 28.4763 35.2568 28.4926 35.3078L28.842 36.4051C28.8665 36.482 28.8196 36.5633 28.7407 36.5805L27.6157 36.8266C27.5634 36.838 27.5226 36.8788 27.5112 36.9311L27.2651 38.0562C27.2479 38.135 27.1666 38.1819 27.0897 38.1574L25.9924 37.808C25.9414 37.7917 25.8856 37.8067 25.8496 37.8463L25.074 38.6975C25.0196 38.7572 24.9258 38.7572 24.8714 38.6975L24.0958 37.8463C24.0598 37.8067 24.004 37.7917 23.953 37.808L22.8557 38.1574C22.7788 38.1819 22.6975 38.135 22.6803 38.0562L22.4343 36.9311C22.4228 36.8788 22.382 36.838 22.3297 36.8266L21.2047 36.5805C21.1259 36.5633 21.0789 36.482 21.1034 36.4051L21.4528 35.3078C21.4691 35.2568 21.4541 35.201 21.4146 35.165L20.5633 34.3894C20.5037 34.3351 20.5037 34.2412 20.5633 34.1869L21.4146 33.4113C21.4541 33.3752 21.4691 33.3194 21.4528 33.2684L21.1034 32.1711C21.0789 32.0942 21.1259 32.013 21.2047 31.9957L22.3297 31.7497C22.382 31.7382 22.4228 31.6974 22.4343 31.6451L22.6803 30.5201C22.6975 30.4413 22.7788 30.3944 22.8557 30.4188L23.953 30.7683C24.004 30.7845 24.0598 30.7696 24.0958 30.73L24.8714 29.8787Z",
    stroke: "#055FFB",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.94531,
    y: 5.38379,
    width: 15.0685,
    height: 3.83562,
    rx: 0.273973,
    stroke: "#055FFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.096 5.38407V3.87722C12.096 3.80157 12.0347 3.74023 11.959 3.74023H5.35153C5.21105 3.74023 5.1616 3.92646 5.28356 3.99616L7.51997 5.2741C7.60838 5.32462 7.61272 5.45053 7.52799 5.50702L5.21214 7.05091C5.09937 7.12609 5.15259 7.30188 5.28813 7.30188H8.94529",
    stroke: "#055FFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.38407V3.87722C21 3.80157 21.0613 3.74023 21.137 3.74023H27.7444C27.8849 3.74023 27.9344 3.92646 27.8124 3.99616L25.576 5.2741C25.4876 5.32462 25.4832 5.45053 25.568 5.50702L27.8838 7.05091C27.9966 7.12609 27.9434 7.30188 27.8078 7.30188H24.1507",
    stroke: "#055FFB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoe);
export default __webpack_public_path__ + "static/media/coe.034b953ab394be584078d2a65add71d2.svg";
export { ForwardRef as ReactComponent };